import React, { useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { LayoutStoreInstance } from '../../../LayoutStore';
import { useHistory } from 'react-router';
import { useCreateScanTunnelMutation } from '../../../graphql/mutations/createScanTunnel.generated';
import { ContentSection } from '../../../components/Layout/ContentSection';
import { Routes } from '@/utils/routes';

export const CreateScanTunnelPage: React.FC = () => {
  const [name, setName] = useState('');

  const [createScanTunnel, { loading, error }] = useCreateScanTunnelMutation();

  const history = useHistory();

  const handleCreateScanTunnel = async () => {
    if (!name) {
      // Assuming only name and email are required
      alert('Name is required');
      return;
    }
    const result = await createScanTunnel({
      variables: { name },
    });
    LayoutStoreInstance.setSuccess('Scan tunnel created');
    if (result.errors) {
      LayoutStoreInstance.setError('Error creating scan tunnel');
    }
    if (result.data?.createScanTunnel?.id) {
      history.push(Routes.scanTunnel(result.data.createScanTunnel.id));
    }
  };

  return (
    <ContentSection title="Create a new Scan Tunnel" collapsable={false}>
      <Form>
        <FormGroup>
          <Label for="accountName">Name</Label>
          <Input
            type="text"
            name="name"
            id="accountName"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </FormGroup>
        {error && <Alert color="danger">Error: {error.message}</Alert>}
        <Button
          color="primary"
          onClick={handleCreateScanTunnel}
          disabled={loading}
        >
          Create Scan Tunnel
        </Button>
      </Form>
    </ContentSection>
  );
};
